import { MaterialService } from './../../../../../shared/src/lib/service/material.service';
import { Conversation } from './../../../../../shared/src/lib/model/conversation.model';
import { Message } from './../../../../../shared/src/lib/model/message.model';
import { HttpParams } from '@angular/common/http';
import { ConversationService } from './../../../../../shared/src/lib/service/conversation.service';
import { Occurrence } from './../../../../../shared/src/lib/model/occurrence.model';
import { Session } from './../../../../../shared/src/lib/model/session.model';
import { Teacher } from './../../../../../shared/src/lib/model/teacher.model';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { AssignExerciceComponent } from '../../upcoming-classes/assign-exercice/assign-exercice.component';
import { ExerciceAssignedComponent } from '../../../../../shared/src/lib/feature/exercice-assigned/exercice-assigned.component';
import { environment } from '../../../../../environments/environment';
import { UpcomingService } from '../../../../../shared/src/lib/service/upcoming.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../../../../../shared/src/lib/service/authentification.service';
import { SessionService } from '../../../../../shared/src/lib/service/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { Formation } from '../../../../../shared/src/lib/model/formation.model';
import { FormationService } from '../../../../../shared/src/lib/service/formation.service';
import { ConversationList } from '../../../../../shared/src/lib/model/conversationList.model';

/**
 * Composant d'affichage d'un upcoming.
 */
@Component({
  selector: 'app-upcoming',
  templateUrl: './upcoming.component.html',
  styleUrls: ['./upcoming.component.scss']
})
export class UpcomingComponent implements OnInit, OnDestroy {
  @Input() upcoming: Occurrence;
  @Input() myIndex;
  @Input() isTeacherInterface;
  student = null;
  formationId = null;
  nextSession = null;
  prevSession: Session = null;
  showUpcoming = false;
  editMessage = false;
  myUser: Teacher = null;
  conversation: Conversation = null;
  defaultAvatar = environment.static + '/avatar.png';
  myMessageCtrl = new FormControl();
  sheetPermission = false;
  isSheetLanguageAvailable = false;
  @Output() displayUpcoming = new EventEmitter();
  messageForm: FormGroup;
  formChanges = false;
  showInfos = false;
  formation: Formation;

  // Modal assign-exercice
  componentToLoad: any;
  componentName: string;
  modalParams: any;
  showAssignModal = false;
  @ViewChild('onsiteAssigned') onsiteAssigned: ExerciceAssignedComponent;
  @ViewChild('offsiteAssigned') offsiteAssigned: ExerciceAssignedComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private upcomingService: UpcomingService,
    private sessionService: SessionService,
    private authenticationService: AuthenticationService,
    private conversationService: ConversationService,
    private builder: FormBuilder,
    private materialService: MaterialService,
  ) { }

  ngOnInit() {
    this.messageForm = this.builder.group({
      message: this.myMessageCtrl
    });

    this.checkSheetsPermission();
    this.myUser = this.authenticationService.getCurrentPersona();
    if (this.myUser) {
      if (this.upcoming && this.upcoming.teacher) {
        this.formationId = this.upcomingService.extractIdFromUrl(this.upcoming.formation)
        this.nextSession = this.getNextSession();
        this.student = this.upcoming.student;
        this.checkAvailableLanguageSheets();
        if (this.messageForm) {
          this.messageForm.patchValue(this.upcoming)
          this.subcribeToFormChanges();
        }
        this.displayUpcoming.emit();
        this.getConversationInformation();
        this.showUpcoming = true;
      }
    }

    if (this.myIndex === 0 && this.upcoming.is_next && !this.isTeacherInterface) {
      this.showInfos = true;
      this.getPreviousSessionDetail();
    }
  }

  ngOnDestroy() {
  }

  // écouteur si le message change.
  subcribeToFormChanges() {
    this.messageForm.valueChanges.subscribe(data => {
      this.formChanges = true;
    })
  }

  getNextSession() {
    if (this.upcoming.is_next === true) {
      return this.upcoming.session;
    } else {
      return null;
    }
  }

  /**
   * mise à jour du prochain cours
   * @param field
   */
  updateNextSession(field) {
    const param = {};
    if (this.formChanges) {
      param[field] = this.messageForm.value.message;
      if (this.nextSession) {
        this.sessionService.patchSession(this.nextSession.url, param)
          .then(res => {
            this.nextSession.message = res['message'];
            this.editMessage = false;
            this.formChanges = false;
            this.materialService.openSnackBar(
              `Message Sauvegardé`,
              'green'
            )
          });
      }
    } else {
      this.editMessage = false;
      this.materialService.openSnackBar(
        `Pas de message Sauvegardé`,
        'red'
      )
    }
  }

  // navigation vers reschedule.
  goToReschedule() {
    const lessOneDay = moment(this.upcoming.start).diff(moment(Date.now()))
    const duration = moment.duration(lessOneDay);
    if (duration.asHours() > 24) {
      this.router.navigate(['upcoming', 'reschedule', this.upcoming.id]);
    } else {
      this.materialService.openSnackBar('Il est impossible d\'annuler un cours moins de 24 h avant le début du cours', 'red');
    }
  }

  showSheet(object) {
    this.router.navigate(['./sheets/sheet/' + object.sheetId + '/student/' + this.student.id], { relativeTo: this.route });
  }

  checkAvailableLanguageSheets() {
    this.isSheetLanguageAvailable = this.authenticationService.checkAvailableLanguageSheets(this.myUser.teach_language.id);
  }

  checkSheetsPermission() {
    this.sheetPermission = this.authenticationService.checkFeaturePermission('sheets');
  }

  getPreviousSessionDetail() {
    if (!this.prevSession && this.upcoming.session) {
      if (this.upcoming.session.previous_session) {
        this.sessionService.getObservableSessionByUrl(this.upcoming.session.previous_session).subscribe(result => {
          if (result) {
            this.prevSession = result;
          }
        });
      }
    }
  }

  getConversationInformation() {
    let params = new HttpParams()
    params = params.append('teacher', this.myUser.id.toString())
    params = params.append('student', this.upcoming.student.id.toString())

    this.conversationService.getConversations(params).subscribe((conversations: ConversationList) => {
      if (conversations.results.length > 0) {
        this.conversation = conversations.results[0];
      }
    });
  }

  goToConversation() {
    if (this.conversation) {
      this.router.navigate(['/messages/conversation/' + this.conversation.id + '/student/' + this.student.id]);
    }
  }

  showInfo() {
    if (this.upcoming.is_next) {
      this.getPreviousSessionDetail();
      this.showInfos = !this.showInfos;
    }
  }

  // Ouvrir la modal d'assignation depuis upcoming
  openAssign(type: 'onsite' | 'offsite', category?: string) {
    if (!this.formationId) return;
    this.componentToLoad = AssignExerciceComponent;
    this.componentName = 'AssignExerciceComponent';
    this.modalParams = {
      formationId: this.formationId,
      typeExercice: type,
      typeCategory: category,
      openInModal: true
    };
    this.showAssignModal = true;
  }

  closeAssignModal() {
    this.showAssignModal = false;
    // Rechargement explicite des listes d'exercices assignés
    this.onsiteAssigned?.reload();
    this.offsiteAssigned?.reload();
  }

  handleModalEvent(event: any) {
    if (event?.component === 'AssignExerciceComponent' && event?.action === 'closed') {
      this.closeAssignModal();
    }
  }

}
